import * as t from "io-ts";
import { nullable } from "./index";
export const createCalendarViewTypes = ({ date, dateTime, }) => {
    const calendarViewRouteT = t.strict({
        id: t.string,
        archived: t.boolean,
        routeStartDate: date,
        routeEndDate: date,
        routeStartTime: dateTime,
        routeEndTime: dateTime,
        cargoOrder: t.array(t.string),
        driversIds: t.array(t.string),
        truckId: nullable(t.string),
        teamId: t.string,
        operationInProgress: t.boolean,
        cargos: t.array(t.strict({
            id: t.string,
            clientId: nullable(t.string),
            description: nullable(t.string),
            cargoTagId: nullable(t.string),
            invoiceable: t.boolean,
            allStopsDeparted: t.boolean,
            firstStopArrived: t.boolean,
            firstStopId: t.string,
            startPlace: t.string,
            stopPlace: t.string,
            startDate: dateTime,
            stopDate: dateTime,
            qualities: t.array(t.string),
            requirements: t.array(t.string),
            startTime: nullable(dateTime),
            stopTime: nullable(dateTime),
            operationInProgress: t.boolean,
            stops: t.array(t.strict({
                id: t.string,
                type: t.union([t.literal("PICKUP"), t.literal("DROPOFF")]),
                date: dateTime,
                startTime: nullable(dateTime),
                stopTime: nullable(dateTime),
                startTimeAssumed: t.boolean,
                stopTimeAssumed: t.boolean,
                cityName: nullable(t.string),
                postcode: nullable(t.string),
            })),
        })),
    });
    const calendarViewDataT = t.array(t.strict({
        truckId: t.string,
        routes: t.array(calendarViewRouteT),
    }));
    const moveStopInRouteReqT = t.strict({
        stopId: t.string,
        cargoId: t.string,
        time: t.string,
        date: dateTime,
        interval: t.union([t.literal("day"), t.literal("week")]),
        startDate: dateTime,
        routeId: t.string,
    });
    return { calendarViewDataT, calendarViewRouteT, moveStopInRouteReqT };
};
//# sourceMappingURL=calendar-view.js.map